import { combineReducers } from "redux";

import * as exchanges from "./exchanges";
import * as isLoadingExchanges from "./isLoadingExchanges";
import * as isLoadingRedeemExchanges from "./isLoadingRedeemExchanges";

export const reducer = combineReducers({
  exchange: exchanges.reducer,
  isLoadingExchanges: isLoadingExchanges.reducer,
  isLoadingRedeemExchanges: isLoadingRedeemExchanges.reducer,
});

export interface StoreState {
  exchange: exchanges.StoreState;
  isLoadingExchanges: isLoadingExchanges.StoreState;
  isLoadingRedeemExchanges: isLoadingRedeemExchanges.StoreState;
}
